export class WbFlightLogVisual {
  PIVOT_KEY: string;
  COUNT: number;
  RATIO: number;
  SUM: number;
  MAX: number;
  MIN: number;
  STDDEV: number;
  AVG: number;
  QUARTILE_1: number;
  MEDIAN: number;
  QUARTILE_3: number;
  RATE: number;
}
